export const IsNotValue = [
  null,
  "null",
  undefined,
  "undefined",
  "+undefined",
  "",
  "<p></p>\n",
  "Invalid Date",
  "Invalid date"
];

export const occupationType = [
  { value: 1, label: "Business Owner" },
  { value: 2, label: "Self Employed" }
];

export const statusList = [
  { value: 0, label: "Waiting For Welcome Kit" },
  { value: 2, label: "Ready to Ship" },
  { value: 1, label: "Courier Delivered" },
  { value: 4, label: "Incorrect Address" }
];

export const gender = [
  { label: "Male", value: 1 },
  { label: "Female", value: 2 }
];

// ===== Prime Stock Module =====

// Same keys the Privilege productHistory filter uses against sh_status.
export const statusLabel = [
  { label: "All", value: -1 },
  { label: "Pending", value: 0 },
  { label: "Received", value: 1 }
];

export const primeProductTypeList = [
  { value: -1, label: "All Product Type" },
  { value: 0, label: "Product" },
  { value: 1, label: "Pin" },
  { value: 2, label: "Welcome Kit" }
];

export const primeProductStatusList = [
  { value: 1, label: "Active" },
  { value: 0, label: "Disabled" }
];

// getprimestockhistory tab values
export const primeStockTabList = [
  { value: 1, label: "Stock In" },
  { value: 2, label: "Stock Out" },
  { value: 3, label: "All" }
];

// getprimepinmemberlist type values
export const primeMemberTabList = [
  { value: 1, label: "Eligible Member" },
  { value: 2, label: "Assign Member" },
  { value: 3, label: "Purchase Member" },
  { value: 4, label: "All Member" }
];

export const primeMemberStatusList = [
  { value: -1, label: "All" },
  { value: 1, label: "Active" },
  { value: 0, label: "De-Active" }
];

export const primeAssignStatusList = [
  { value: 1, label: "Assigned" },
  { value: 2, label: "Rejected" },
  { value: 3, label: "Not Eligible" },
  { value: 4, label: "Revoked" }
];

// prime_products.p_type - kept in step with PRIME_PRODUCT_TYPE in
// config/constants.js on the backend.
export const PRIME_PRODUCT_TYPE = {
  PRODUCT: 0,
  PIN: 1,
  WELCOME_KIT: 2
};
